import React from "react";
import IExamReportInformationState, { IExamReportInformationProps } from "./ExamReportInformation.models";
import examInformationImage from "../../../../assest/images/card-image/exam-report-avatar.png";
import examAvatarInfo from "../../../../assest/images/card-image/ItemAvatarInfo.png";
import './ExamReportInformation.scss'
import moment from "moment";

export default class ExamReportInformation extends React.PureComponent<IExamReportInformationProps, IExamReportInformationState> {
    constructor(props: any) {
        super(props);
        this.state = {}
    }

    render(): React.ReactNode {
        let { examInformation } = this.props;
        return (<>
            {
                examInformation && <>
                    {this.examInformationContentView()}
                    {this.courseStatisticsContentView()}
                </>
            }
        </>);
    }

    examInformationContentView() {
        let { examInformation } = this.props;

        let items = [
            { title: 'شماره آزمون:', value: examInformation?.id },
            { title: 'عنوان:', value: examInformation?.title },
            { title: 'تاریخ برگزاری:', value: (examInformation?.examDate) ? moment(examInformation?.examDate, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD') : '-' },
            { title: 'رشته:', value: examInformation?.fieldTitle },
            { title: 'پایه:', value: examInformation?.baseTitles }
        ]

        if (!examInformation?.alreadyJoined)
            items.push({ title: 'شرکت کنندگان:', value: examInformation?.participantsCount })

        return (
            <div className="exam-info-view-area">
                <div className="tk-card">
                    <div className="card-icon">
                        <img src={examAvatarInfo} style={{ width: '64px' }} alt="exam icon" />
                    </div>
                    <div className="card-title">
                        <label className="font-bold f-16 text-dark">اطلاعات آزمون</label>
                    </div>
                    <div className="col-12 user-info">
                        {
                            items.map((item, index) => {
                                return <div className="tk-inline" key={index}>
                                    <div className="col-6 notspace text-dark">
                                        <label>{item.title}</label>
                                    </div>
                                    <div className="col-6 notspace info">
                                        <label>{item.value}</label>
                                    </div>
                                </div>
                            })
                        }
                    </div>
                    {
                        examInformation?.alreadyJoined && <div className="notice-grey">به علت اینکه شما قبلا در این آزمون شرکت کرده‌اید، نتیجه‌ی آزمون شما در رقابت در نظر گرفته نمی شود.</div>
                    }
                </div>
            </div>
        )
    }

    courseStatisticsContentView() {
        let { examInformation, chartData } = this.props;

        return (
            <div className="exam-info-view-area">
                <div className="tk-card">
                    <div className="card-icon">
                        <img src={examInformationImage} style={{ width: '64px' }} alt="exam icon" />
                    </div>
                    <div className="card-title">
                        <label className="font-bold f-16 text-dark">جدول آمار دروس</label>
                    </div>
                    <div className="col-12 user-info">
                        <div className="exam-course-statistics-table-area">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>ردیف</th>
                                        <th>نام درس</th>
                                        <th>تعداد</th>
                                        <th>درست</th>
                                        <th>غلط</th>
                                        <th>نزده</th>
                                        <th>نمره</th>
                                        {
                                            !examInformation?.alreadyJoined &&
                                            <>
                                                <th>تراز</th>
                                                <th>بالاترین نمره</th>
                                                <th>بالاترین تراز</th>
                                                <th>رتبه آزمون</th>
                                                <th>میانگین نمره آزمون</th>
                                            </>
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        examInformation?.courseStatistics.map((courseStatistic, index) => {
                                            return <tr key={index}>
                                                <td>*{index + 1}</td>
                                                <td className="font-bold">{courseStatistic.courseTitle}</td>
                                                <td>{courseStatistic.count}</td>
                                                <td>{courseStatistic.correctCount}</td>
                                                <td>{courseStatistic.wrongCount}</td>
                                                <td>{courseStatistic.unAnswered}</td>
                                                <td>{courseStatistic.percent}</td>
                                                {
                                                    !examInformation?.alreadyJoined &&
                                                    <>
                                                        <td>{courseStatistic.level}</td>
                                                        <td>{courseStatistic.topPercent}</td>
                                                        <td>{chartData?.filter(item => item.key == "TOP")[0]?.data.filter(item => item.title == courseStatistic.courseTitle)[0].value}</td>
                                                        <td>{courseStatistic.rank}</td>
                                                        <td>{courseStatistic.avragePrecent}</td>
                                                    </>
                                                }
                                            </tr>
                                        })
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td></td>
                                        <td className="font-bold">جمع کل</td>
                                        <td>{examInformation?.totalQuestion}</td>
                                        <td>{examInformation?.examCorrectAnswer}</td>
                                        <td>{examInformation?.examWrongAnswer}</td>
                                        <td>{examInformation?.examUnAnswer}</td>
                                        <td>{examInformation?.examPercent}</td>
                                        {!examInformation?.alreadyJoined && <td>{examInformation?.examLevel}</td>}
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}